










import 'firebaseui/dist/firebaseui.css';

import firebase from 'firebase/app';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/common/Loading.vue';
import router from '@/router';

@Component({
  components: {
    Loading,
  },
})
export default class LoginCard extends Vue {
  async login() {
    console.log('login');
    const provider = new firebase.auth.GoogleAuthProvider();
    try {
      const user = await firebase.auth().signInWithPopup(provider);
      console.log(`OK: user=${user}`);
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  }

  // // serverにidTokenを送って検証
  // private async loginToServer(user: firebase.User) {
  //   try {
  //     const idToken = await user.getIdToken();
  //     const formData = new FormData();
  //     formData.append('idToken', idToken);

  //     // TOOD: とりあえずGoのサーバが動いてる前提
  //     const resp = await fetch('http://localhost:8888/login', {
  //       method: `POST`,
  //       mode: `cors`,
  //       redirect: `error`,
  //       body: formData,
  //     });
  //     if (!resp.ok) {
  //       console.log(`loginToServer: login failed. statusCode=${resp.status}`);
  //       this.to('/');
  //       return;
  //     }
  //     const json = await resp.json();
  //     console.log(`loginToServer: login succeeded: resp=${json}`);
  //     this.to('/');
  //   } catch (e) {
  //     console.log(`loginToServer: login error: ${e}`);
  //     this.to('/');
  //   }
  // }

  // private to(path: string) {
  //   router.push(path);
  // }
}
